import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

const MISSING_USER_ID_HEADER = 'X-Real-UserId';

/**
 * Узнаёт ответ бэкенда о запросе без аутентификации.
 * Машиночитаемого кода у этой ошибки нет, поэтому опознаём по тексту сообщения
 */
export function isMissingUserIdHeaderError(error: unknown): boolean {
  return (
    HttpBadStatusCodeError.isLike(error) &&
    error.statusCode === 400 &&
    typeof error.message === 'string' &&
    error.message.includes(MISSING_USER_ID_HEADER)
  );
}
